import { compact as _compact, join as _join } from 'lodash';
import querystring from 'querystring';

const BASE_URL = 'https://apidev.gopherapps.com/';

function getKeyValueString(keyValues) {
  return querystring.stringify(keyValues);
}

function getQueryString(config) {
  if (!config || !config.queryParams) {
    return '';
  }
  const queryStringParts = [];
  if (config.queryParams) {
    queryStringParts.push(getKeyValueString(config.queryParams));
  }
  return `?${_join(_compact(queryStringParts), '&')}`;
}

export default {
  // delete(url) {
  //   return axios.delete(url);
  // },
  get(url, config) {
    let newUrl = url;
    if (url.indexOf('http') < 0) {
      newUrl = BASE_URL + url;
    }
    return fetch(`${newUrl}${getQueryString(config)}`)
      .then(response => response.json());
  },
  // post(ur, data) {
  //   return axios.post(url, data);
  // },
  // put(url, data) {
  //   return axios.put(url, data);
  // }
};


// WEBPACK FOOTER //
// ./src/api/resource.js